import { ResultRecord } from "@rsm-hcd/javascript-core";
import ConversationRecord from "models/view-models/conversations/conversation-record";
import { Dispatch } from "react";
import { ConversationsAction } from "utilities/atoms/conversations/current-conversation/conversation-atom.reducer";
import ConversationService from "utilities/services/conversations/conversation-service";

/**
 * Starts a new conversation.
 * This thunk will create a new conversation and update the state accordingly.
 */
export const loadConversation =
    (id: string) => async (dispatch: Dispatch<ConversationsAction>) => {
        dispatch({ type: "LOADING_CONVERSATION", id });

        let result: ResultRecord<ConversationRecord> | undefined;

        try {
            if (!id) {
                dispatch({
                    type: "ERROR",
                    error: new Error(
                        "Conversation ID is required to load a conversation."
                    ),
                });
                return;
            }

            const response = await ConversationService.get({ id });
            result = response.result;

            if (result?.doesNotHaveErrors() && response.resultObject) {
                dispatch({
                    type: "LOAD_CONVERSATION",
                    conversation: response.resultObject,
                });

                return;
            }
        } catch (error) {
            result = new ResultRecord<ConversationRecord>().addError(
                "ERROR",
                `${error}`
            );
        }

        dispatch({
            type: "ERROR",
            error: new Error(
                (
                    result?.listErrorMessages() || [
                        "Failed to load conversation",
                    ]
                ).join(", ")
            ),
        });
    };
